import Swal from "sweetalert2";
import HistorialEstudiosService from "../services/HistorialEstudiosService";
import HistorialService from "../services/HistorialService";

export const formatFechaHistorial = (fechaInput) => {
  if (!fechaInput) return "";
  // Si la fecha viene como string ISO o formato SQL
  let dateObj;
  if (typeof fechaInput === "string") {
    // Reemplazar espacio por T si es datetime SQL
    const formatted = fechaInput.includes(" ") ? fechaInput.replace(" ", "T") : fechaInput;
    dateObj = new Date(formatted);
  } else {
    dateObj = new Date(fechaInput);
  }

  if (isNaN(dateObj.getTime())) return fechaInput;

  const dia = String(dateObj.getDate()).padStart(2, "0");
  const meses = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
  ];
  const mes = meses[dateObj.getMonth()];
  const anio = dateObj.getFullYear();
  const horas = String(dateObj.getHours()).padStart(2, "0");
  const minutos = String(dateObj.getMinutes()).padStart(2, "0");

  return `${dia} ${mes}, ${anio} ${horas}:${minutos} h`;
};

export const renderAccionHistorial = (tipoAccion, nombreEstudio) => {
  const estudioTxt = nombreEstudio ? nombreEstudio.toUpperCase() : "";

  if (tipoAccion === "L") {
    return `<span style="background-color: #388e3c; color: white; padding: 2px 8px; border-radius: 4px; font-weight: bold; font-size: 0.78rem; margin-right: 6px; display: inline-block;">Liberó</span> ${estudioTxt}`;
  }
  if (tipoAccion === "R") {
    return `<span style="background-color: #1976d2; color: white; padding: 2px 8px; border-radius: 4px; font-weight: bold; font-size: 0.78rem; margin-right: 6px; display: inline-block;">Reportó</span> ${estudioTxt}`;
  }
  if (tipoAccion === "V") {
    return `<span style="background-color: #e65100; color: white; padding: 2px 8px; border-radius: 4px; font-weight: bold; font-size: 0.78rem; margin-right: 6px; display: inline-block;">Revisó</span> ${estudioTxt}`;
  }
  if (tipoAccion === "P") {
    return `<span style="background-color: #616161; color: white; padding: 2px 8px; border-radius: 4px; font-weight: bold; font-size: 0.78rem; margin-right: 6px; display: inline-block;">En proceso</span> ${estudioTxt}`;
  }
  if (tipoAccion === "I") {
    return `<i class="fas fa-print" style="font-size: 1.05rem; color: #0f4b75; margin-right: 6px; vertical-align: middle;"></i> ${estudioTxt}`;
  }
  if (tipoAccion === "D") {
    return `<i class="fas fa-download" style="font-size: 1.05rem; color: #006787; margin-right: 6px; vertical-align: middle;"></i> ${estudioTxt}`;
  }
  return `${tipoAccion || ""} ${estudioTxt}`;
};

export const mostrarModalHistorialEstudio = async (solicitud, estudio) => {
  const idSolicitud = solicitud.idSolicitud || solicitud.orden || solicitud.codigo;
  const idEstudio = estudio.idEstudio || estudio.idEstudioSec;
  const nombreEstudio = estudio.nombre || estudio.nombreEstudio || "";

  const historial = await HistorialEstudiosService.getHistorialPorEstudio(
    idSolicitud,
    idEstudio
  );

  const items = Array.isArray(historial) ? historial : [];
  let currentPage = 1;
  const itemsPerPage = 8;

  const renderContent = () => {
    const totalPages = Math.ceil(items.length / itemsPerPage) || 1;
    if (currentPage > totalPages) currentPage = totalPages;
    if (currentPage < 1) currentPage = 1;

    const startIdx = (currentPage - 1) * itemsPerPage;
    const pageItems = items.slice(startIdx, startIdx + itemsPerPage);

    let filasHtml = "";
    if (pageItems.length === 0) {
      filasHtml = `
        <tr>
          <td colspan="3" style="text-align: center; padding: 15px; color: #666; font-style: italic;">
            No se encontraron registros de modificación para este estudio.
          </td>
        </tr>
      `;
    } else {
      pageItems.forEach((item, index) => {
        const bg = index % 2 === 0 ? "#f9f9f9" : "#ffffff";
        filasHtml += `
          <tr style="background-color: ${bg}; border-bottom: 1px solid #dcdcdc; font-size: 0.88rem;">
            <td style="padding: 8px 12px; text-align: left; color: #222; font-weight: 500; border-right: 1px solid #e0e0e0;">
              ${item.nombreEmpleado || "SISTEMA"}
            </td>
            <td style="padding: 8px 12px; text-align: left; color: #222; border-right: 1px solid #e0e0e0;">
              ${renderAccionHistorial(item.tipoAccion, item.nombreEstudio || nombreEstudio)}
            </td>
            <td style="padding: 8px 12px; text-align: right; color: #333; white-space: nowrap;">
              ${formatFechaHistorial(item.fechaModificacion)}
            </td>
          </tr>
        `;
      });
    }

    const tableContainer = document.getElementById("swal-historial-estudio-table-body");
    if (tableContainer) tableContainer.innerHTML = filasHtml;

    const pageInfo = document.getElementById("swal-historial-estudio-page-info");
    if (pageInfo) pageInfo.innerText = `Página ${currentPage} de ${totalPages} (${items.length} registros)`;

    const btnPrev = document.getElementById("swal-historial-estudio-btn-prev");
    if (btnPrev) {
      btnPrev.disabled = currentPage <= 1;
      btnPrev.style.opacity = currentPage <= 1 ? "0.5" : "1";
      btnPrev.style.cursor = currentPage <= 1 ? "not-allowed" : "pointer";
    }

    const btnNext = document.getElementById("swal-historial-estudio-btn-next");
    if (btnNext) {
      btnNext.disabled = currentPage >= totalPages;
      btnNext.style.opacity = currentPage >= totalPages ? "0.5" : "1";
      btnNext.style.cursor = currentPage >= totalPages ? "not-allowed" : "pointer";
    }
  };

  const tableHtml = `
    <div style="width: 100%; overflow-x: auto; font-family: sans-serif; margin-top: 10px;">
      <table style="width: 100%; border-collapse: collapse; border: 1px solid #0e4871; box-shadow: 0 2px 5px rgba(0,0,0,0.15);">
        <thead>
          <tr style="background: linear-gradient(180deg, #0f4b75 0%, #006787 100%); color: white; font-size: 0.9rem;">
            <th style="padding: 10px 12px; text-align: left; border-right: 1px solid rgba(255,255,255,0.2);">Nombre del empleado</th>
            <th style="padding: 10px 12px; text-align: left; border-right: 1px solid rgba(255,255,255,0.2);">Acción realizada</th>
            <th style="padding: 10px 12px; text-align: right;">Fecha de modificación</th>
          </tr>
        </thead>
        <tbody id="swal-historial-estudio-table-body">
        </tbody>
      </table>
      <div style="margin-top: 14px; display: flex; justify-content: space-between; align-items: center;">
        <span id="swal-historial-estudio-page-info" style="font-size: 0.85rem; color: #64748b; font-weight: 500;"></span>
        <div style="display: flex; gap: 8px;">
          <button id="swal-historial-estudio-btn-prev" style="padding: 6px 14px; background: #006787; color: white; border: none; border-radius: 4px; font-size: 0.85rem; font-weight: 600; transition: opacity 0.2s;">Anterior</button>
          <button id="swal-historial-estudio-btn-next" style="padding: 6px 14px; background: #006787; color: white; border: none; border-radius: 4px; font-size: 0.85rem; font-weight: 600; transition: opacity 0.2s;">Siguiente</button>
        </div>
      </div>
    </div>
  `;

  Swal.fire({
    title: `Historial de Modificaciones`,
    html: tableHtml,
    width: "750px",
    confirmButtonColor: "#006787",
    confirmButtonText: "Cerrar",
    customClass: {
      popup: "swalMaxHeight"
    },
    didOpen: (popup) => {
      renderContent();
      const btnPrev = popup.querySelector("#swal-historial-estudio-btn-prev");
      if (btnPrev) {
        btnPrev.addEventListener("click", () => {
          if (currentPage > 1) {
            currentPage--;
            renderContent();
          }
        });
      }
      const btnNext = popup.querySelector("#swal-historial-estudio-btn-next");
      if (btnNext) {
        btnNext.addEventListener("click", () => {
          const totalPages = Math.ceil(items.length / itemsPerPage) || 1;
          if (currentPage < totalPages) {
            currentPage++;
            renderContent();
          }
        });
      }
    }
  });
};

export const mostrarModalHistorialImpresionEnvio = async (solicitud) => {
  const idSolicitud = solicitud.idSolicitud || solicitud.orden || solicitud.codigo;

  Swal.fire({
    title: "Cargando historial de impresión...",
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading(),
  });

  const historial = await HistorialEstudiosService.getHistorialSolicitudImpresionEnvio(
    idSolicitud
  );

  const items = Array.isArray(historial) ? historial : [];
  let currentSearch = "";
  let currentPage = 1;
  const itemsPerPage = 10;

  const renderContent = () => {
    const searchLower = currentSearch.toLowerCase().trim();
    const filtered = items.filter((item) => {
      if (!searchLower) return true;
      const emp = (item.nombreEmpleado || "").toLowerCase();
      const est = (item.nombreEstudio || "").toLowerCase();
      const acc = (item.tipoAccion || "").toLowerCase();
      return emp.includes(searchLower) || est.includes(searchLower) || acc.includes(searchLower);
    });

    const totalPages = Math.ceil(filtered.length / itemsPerPage) || 1;
    if (currentPage > totalPages) currentPage = totalPages;
    if (currentPage < 1) currentPage = 1;

    const startIdx = (currentPage - 1) * itemsPerPage;
    const pageItems = filtered.slice(startIdx, startIdx + itemsPerPage);

    let rowsHtml = "";
    if (pageItems.length === 0) {
      rowsHtml = `
        <tr>
          <td colspan="3" style="text-align: center; padding: 25px; color: #666; font-style: italic;">
            No hay registros de impresión ni descarga de PDF para esta solicitud.
          </td>
        </tr>
      `;
    } else {
      pageItems.forEach((item, index) => {
        const bg = index % 2 === 0 ? "#f9fbfd" : "#ffffff";
        rowsHtml += `
          <tr style="background-color: ${bg}; border-bottom: 1px solid #dcdcdc; font-size: 0.88rem;">
            <td style="padding: 10px 12px; text-align: left; color: #222; font-weight: 500; border-right: 1px solid #e0e0e0;">
              ${item.nombreEmpleado || "SISTEMA"}
            </td>
            <td style="padding: 10px 12px; text-align: left; color: #222; border-right: 1px solid #e0e0e0;">
              ${renderAccionHistorial(item.tipoAccion, item.nombreEstudio)}
            </td>
            <td style="padding: 10px 12px; text-align: right; color: #333; white-space: nowrap;">
              ${formatFechaHistorial(item.fechaModificacion)}
            </td>
          </tr>
        `;
      });
    }

    const tableContainer = document.getElementById("swal-impresion-table-body");
    if (tableContainer) tableContainer.innerHTML = rowsHtml;

    const pageInfo = document.getElementById("swal-impresion-page-info");
    if (pageInfo) pageInfo.innerText = `Página ${currentPage} de ${totalPages} (${filtered.length} registros)`;

    const btnPrev = document.getElementById("swal-impresion-btn-prev");
    if (btnPrev) btnPrev.disabled = currentPage <= 1;

    const btnNext = document.getElementById("swal-impresion-btn-next");
    if (btnNext) btnNext.disabled = currentPage >= totalPages;
  };

  const htmlModal = `
    <div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; text-align: left;">
      <div style="margin-bottom: 12px; display: flex; justify-content: space-between; align-items: center;">
        <input id="swal-impresion-search" type="text" placeholder="Buscar por empleado u estudio..." 
          style="width: 100%; padding: 8px 14px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 0.9rem; outline: none; box-shadow: inset 0 1px 2px rgba(0,0,0,0.05);" />
      </div>
      <div style="width: 100%; overflow-x: auto; border: 1px solid #cbd5e1; border-radius: 8px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);">
        <table style="width: 100%; border-collapse: collapse; background: white;">
          <thead>
            <tr style="background: linear-gradient(180deg, #0f4b75 0%, #006787 100%); color: white; font-size: 0.9rem;">
              <th style="padding: 10px 12px; text-align: left; border-right: 1px solid rgba(255,255,255,0.2);">Nombre del empleado</th>
              <th style="padding: 10px 12px; text-align: left; border-right: 1px solid rgba(255,255,255,0.2);">Acción realizada</th>
              <th style="padding: 10px 12px; text-align: right;">Fecha y hora</th>
            </tr>
          </thead>
          <tbody id="swal-impresion-table-body"></tbody>
        </table>
      </div>
      <div style="margin-top: 14px; display: flex; justify-content: space-between; align-items: center;">
        <span id="swal-impresion-page-info" style="font-size: 0.85rem; color: #64748b; font-weight: 500;"></span>
        <div style="display: flex; gap: 8px;">
          <button id="swal-impresion-btn-prev" style="padding: 6px 14px; background: #006787; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 0.85rem; font-weight: 600; transition: opacity 0.2s;">Anterior</button>
          <button id="swal-impresion-btn-next" style="padding: 6px 14px; background: #006787; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 0.85rem; font-weight: 600; transition: opacity 0.2s;">Siguiente</button>
        </div>
      </div>
    </div>
  `;

  Swal.fire({
    title: `Historial Impresión / Envío`,
    html: htmlModal,
    width: "820px",
    showCloseButton: true,
    confirmButtonColor: "#006787",
    confirmButtonText: "Cerrar",
    didOpen: (popup) => {
      renderContent();
      const searchInput = popup.querySelector("#swal-impresion-search");
      if (searchInput) {
        searchInput.addEventListener("input", (e) => {
          currentSearch = e.target.value;
          currentPage = 1;
          renderContent();
        });
      }
      const btnPrev = popup.querySelector("#swal-impresion-btn-prev");
      if (btnPrev) {
        btnPrev.addEventListener("click", () => {
          if (currentPage > 1) {
            currentPage--;
            renderContent();
          }
        });
      }
      const btnNext = popup.querySelector("#swal-impresion-btn-next");
      if (btnNext) {
        btnNext.addEventListener("click", () => {
          currentPage++;
          renderContent();
        });
      }
    },
  });
};

export const mostrarModalHistorialPagos = async (idSolicitud) => {
  if (!idSolicitud) return;

  Swal.fire({
    title: "Cargando historial de pagos...",
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading(),
  });

  const data = await HistorialService.getHistorialPagos(idSolicitud);
  const items = Array.isArray(data) ? data : [];
  let currentSearch = "";
  let currentPage = 1;
  const itemsPerPage = 6;

  const renderContent = () => {
    const searchLower = currentSearch.toLowerCase().trim();
    const filtered = items.filter((item) => {
      if (!searchLower) return true;
      const emp = (item.nombreEmpleado || "").toLowerCase();
      const suc = (item.nombreSucursal || "").toLowerCase();
      const op = (item.operacion || "").toLowerCase();
      return emp.includes(searchLower) || suc.includes(searchLower) || op.includes(searchLower);
    });

    const totalPages = Math.ceil(filtered.length / itemsPerPage) || 1;
    if (currentPage > totalPages) currentPage = totalPages;

    const startIdx = (currentPage - 1) * itemsPerPage;
    const pageItems = filtered.slice(startIdx, startIdx + itemsPerPage);

    let rowsHtml = "";
    if (pageItems.length === 0) {
      rowsHtml = `
        <tr>
          <td colspan="6" style="text-align:center;padding:25px;color:#777;font-style:italic;">
            No se encontraron registros de pago.
          </td>
        </tr>`;
    } else {
      pageItems.forEach((item, idx) => {
        const bg = idx % 2 === 0 ? "#f9fbfd" : "#ffffff";
        const cantidadStr = `$${Number(item.cantidad || 0).toFixed(2)}`;
        let badgeColor = "#2e7d32";
        let badgeBg = "#e8f5e9";
        if (item.operacion?.includes("Cancelación")) {
          badgeColor = "#c62828";
          badgeBg = "#ffebee";
        } else if (item.operacion?.includes("Eliminación")) {
          badgeColor = "#ef6c00";
          badgeBg = "#fff3e0";
        }

        rowsHtml += `
          <tr style="background:${bg};border-bottom:1px solid #e2e8f0;font-size:0.85rem;">
            <td style="padding:10px 12px;text-align:left;color:#1e293b;font-weight:500;border-right:1px solid #edf2f7;">${item.nombreEmpleado || "EMPLEADO"}</td>
            <td style="padding:10px 12px;text-align:left;color:#334155;border-right:1px solid #edf2f7;">${item.nombreSucursal || "-"}</td>
            <td style="padding:10px 12px;text-align:center;color:#334155;border-right:1px solid #edf2f7;text-transform:capitalize;">${item.formaPago || "Efectivo"}</td>
            <td style="padding:10px 12px;text-align:right;color:#0f172a;font-weight:700;border-right:1px solid #edf2f7;">${cantidadStr}</td>
            <td style="padding:10px 12px;text-align:center;color:#475569;white-space:nowrap;border-right:1px solid #edf2f7;">${formatFechaHistorial(item.fecha)}</td>
            <td style="padding:10px 12px;text-align:left;"><span style="background:${badgeBg};color:${badgeColor};padding:3px 10px;border-radius:12px;font-weight:600;font-size:0.78rem;">${item.operacion || "Pago"}</span></td>
          </tr>`;
      });
    }

    const tableContainer = document.getElementById("swal-pagos-table-body");
    if (tableContainer) tableContainer.innerHTML = rowsHtml;

    const pageInfo = document.getElementById("swal-pagos-page-info");
    if (pageInfo) pageInfo.innerText = `Página ${currentPage} de ${totalPages} (${filtered.length} registros)`;

    const btnPrev = document.getElementById("swal-pagos-btn-prev");
    if (btnPrev) btnPrev.disabled = currentPage <= 1;

    const btnNext = document.getElementById("swal-pagos-btn-next");
    if (btnNext) btnNext.disabled = currentPage >= totalPages;
  };

  const htmlModal = `
    <div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; text-align: left;">
      <div style="margin-bottom: 12px; display: flex; justify-content: space-between; align-items: center;">
        <input id="swal-pagos-search" type="text" placeholder="Buscar por empleado, sucursal u operación..." 
          style="width: 100%; padding: 8px 14px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 0.9rem; outline: none; box-shadow: inset 0 1px 2px rgba(0,0,0,0.05);" />
      </div>
      <div style="width: 100%; overflow-x: auto; border: 1px solid #cbd5e1; border-radius: 8px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);">
        <table style="width: 100%; border-collapse: collapse; background: white;">
          <thead>
            <tr style="background: linear-gradient(180deg, #18234f 0%, #006787 100%); color: white; font-size: 0.85rem;">
              <th style="padding: 10px 12px; text-align: left; border-right: 1px solid rgba(255,255,255,0.15);">Empleado</th>
              <th style="padding: 10px 12px; text-align: left; border-right: 1px solid rgba(255,255,255,0.15);">Sucursal</th>
              <th style="padding: 10px 12px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15);">Forma de pago</th>
              <th style="padding: 10px 12px; text-align: right; border-right: 1px solid rgba(255,255,255,0.15);">Cantidad</th>
              <th style="padding: 10px 12px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15);">Fecha</th>
              <th style="padding: 10px 12px; text-align: left;">Operación</th>
            </tr>
          </thead>
          <tbody id="swal-pagos-table-body"></tbody>
        </table>
      </div>
      <div style="margin-top: 14px; display: flex; justify-content: space-between; align-items: center;">
        <span id="swal-pagos-page-info" style="font-size: 0.85rem; color: #64748b; font-weight: 500;"></span>
        <div style="display: flex; gap: 8px;">
          <button id="swal-pagos-btn-prev" style="padding: 6px 14px; background: #18234f; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 0.85rem; font-weight: 600; transition: opacity 0.2s;">Anterior</button>
          <button id="swal-pagos-btn-next" style="padding: 6px 14px; background: #18234f; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 0.85rem; font-weight: 600; transition: opacity 0.2s;">Siguiente</button>
        </div>
      </div>
    </div>
  `;

  Swal.fire({
    title: "Historial de Pagos",
    html: htmlModal,
    width: "920px",
    showCloseButton: true,
    confirmButtonColor: "#18234f",
    confirmButtonText: "Cerrar",
    didOpen: (popup) => {
      renderContent();
      const searchInput = popup.querySelector("#swal-pagos-search");
      if (searchInput) {
        searchInput.addEventListener("input", (e) => {
          currentSearch = e.target.value;
          currentPage = 1;
          renderContent();
        });
      }
      const btnPrev = popup.querySelector("#swal-pagos-btn-prev");
      if (btnPrev) {
        btnPrev.addEventListener("click", () => {
          if (currentPage > 1) {
            currentPage--;
            renderContent();
          }
        });
      }
      const btnNext = popup.querySelector("#swal-pagos-btn-next");
      if (btnNext) {
        btnNext.addEventListener("click", () => {
          currentPage++;
          renderContent();
        });
      }
    },
  });
};

export const mostrarModalHistorialSolicitud = async (idSolicitud) => {
  if (!idSolicitud) return;

  Swal.fire({
    title: "Cargando historial de la solicitud...",
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading(),
  });

  const data = await HistorialService.getHistorialEventos(idSolicitud);
  let items = Array.isArray(data) ? data : [];

  if (items.length === 0) {
    try {
      const resEst = await HistorialEstudiosService.getHistorialPorEstudio(idSolicitud, 0);
      if (Array.isArray(resEst) && resEst.length > 0) {
        items = resEst.map((item) => ({
          nombreEmpleado: item.nombreEmpleado || "EMPLEADO",
          operacion: item.nombreEstudio || item.tipoAccion || "Movimiento registrado",
          fecha: item.fechaModificacion || "",
        }));
      }
    } catch (e) {
      console.warn("Fallback local para eventos:", e);
    }
  }

  let currentSearch = "";
  let currentPage = 1;
  const itemsPerPage = 6;

  const renderContent = () => {
    const searchLower = currentSearch.toLowerCase().trim();
    const filtered = items.filter((item) => {
      if (!searchLower) return true;
      const emp = (item.nombreEmpleado || "").toLowerCase();
      const op = (item.operacion || "").toLowerCase();
      return emp.includes(searchLower) || op.includes(searchLower);
    });

    const totalPages = Math.ceil(filtered.length / itemsPerPage) || 1;
    if (currentPage > totalPages) currentPage = totalPages;

    const startIdx = (currentPage - 1) * itemsPerPage;
    const pageItems = filtered.slice(startIdx, startIdx + itemsPerPage);

    let rowsHtml = "";
    if (pageItems.length === 0) {
      rowsHtml = `
        <tr>
          <td colspan="3" style="text-align:center;padding:25px;color:#777;font-style:italic;">
            No se encontraron movimientos para esta solicitud.
          </td>
        </tr>`;
    } else {
      pageItems.forEach((item, idx) => {
        const bg = idx % 2 === 0 ? "#f9fbfd" : "#ffffff";
        rowsHtml += `
          <tr style="background:${bg};border-bottom:1px solid #e2e8f0;font-size:0.88rem;">
            <td style="padding:10px 14px;text-align:left;color:#1e293b;font-weight:500;border-right:1px solid #edf2f7;white-space:nowrap;">${item.nombreEmpleado || "EMPLEADO"}</td>
            <td style="padding:10px 14px;text-align:left;color:#334155;border-right:1px solid #edf2f7;">${item.operacion || "Operación realizada"}</td>
            <td style="padding:10px 14px;text-align:center;color:#475569;white-space:nowrap;">${formatFechaHistorial(item.fecha)}</td>
          </tr>`;
      });
    }

    const tableContainer = document.getElementById("swal-solicitud-table-body");
    if (tableContainer) tableContainer.innerHTML = rowsHtml;

    const pageInfo = document.getElementById("swal-solicitud-page-info");
    if (pageInfo) pageInfo.innerText = `Página ${currentPage} de ${totalPages} (${filtered.length} registros)`;

    const btnPrev = document.getElementById("swal-solicitud-btn-prev");
    if (btnPrev) btnPrev.disabled = currentPage <= 1;

    const btnNext = document.getElementById("swal-solicitud-btn-next");
    if (btnNext) btnNext.disabled = currentPage >= totalPages;
  };

  const htmlModal = `
    <div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; text-align: left;">
      <div style="margin-bottom: 12px; display: flex; justify-content: space-between; align-items: center;">
        <input id="swal-solicitud-search" type="text" placeholder="Buscar por empleado u operación..." 
          style="width: 100%; padding: 8px 14px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 0.9rem; outline: none; box-shadow: inset 0 1px 2px rgba(0,0,0,0.05);" />
      </div>
      <div style="width: 100%; overflow-x: auto; border: 1px solid #cbd5e1; border-radius: 8px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);">
        <table style="width: 100%; border-collapse: collapse; background: white;">
          <thead>
            <tr style="background: linear-gradient(180deg, #18234f 0%, #006787 100%); color: white; font-size: 0.88rem;">
              <th style="padding: 10px 14px; text-align: left; border-right: 1px solid rgba(255,255,255,0.15); width: 25%;">Empleado</th>
              <th style="padding: 10px 14px; text-align: left; border-right: 1px solid rgba(255,255,255,0.15);">Operación realizada</th>
              <th style="padding: 10px 14px; text-align: center; width: 25%;">Fecha y hora</th>
            </tr>
          </thead>
          <tbody id="swal-solicitud-table-body"></tbody>
        </table>
      </div>
      <div style="margin-top: 14px; display: flex; justify-content: space-between; align-items: center;">
        <span id="swal-solicitud-page-info" style="font-size: 0.85rem; color: #64748b; font-weight: 500;"></span>
        <div style="display: flex; gap: 8px;">
          <button id="swal-solicitud-btn-prev" style="padding: 6px 14px; background: #18234f; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 0.85rem; font-weight: 600; transition: opacity 0.2s;">Anterior</button>
          <button id="swal-solicitud-btn-next" style="padding: 6px 14px; background: #18234f; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 0.85rem; font-weight: 600; transition: opacity 0.2s;">Siguiente</button>
        </div>
      </div>
    </div>
  `;

  Swal.fire({
    title: "Historial de Solicitud",
    html: htmlModal,
    width: "820px",
    showCloseButton: true,
    confirmButtonColor: "#18234f",
    confirmButtonText: "Cerrar",
    didOpen: (popup) => {
      renderContent();
      const searchInput = popup.querySelector("#swal-solicitud-search");
      if (searchInput) {
        searchInput.addEventListener("input", (e) => {
          currentSearch = e.target.value;
          currentPage = 1;
          renderContent();
        });
      }
      const btnPrev = popup.querySelector("#swal-solicitud-btn-prev");
      if (btnPrev) {
        btnPrev.addEventListener("click", () => {
          if (currentPage > 1) {
            currentPage--;
            renderContent();
          }
        });
      }
      const btnNext = popup.querySelector("#swal-solicitud-btn-next");
      if (btnNext) {
        btnNext.addEventListener("click", () => {
          currentPage++;
          renderContent();
        });
      }
    },
  });
};

export const abrirModalSeleccionHistorial = (idSolicitud) => {
  if (!idSolicitud) return;

  Swal.fire({
    title: "¿Qué historial desea ver?",
    text: "Seleccione el tipo de historial que requiere consultar:",
    icon: "question",
    showCancelButton: true,
    showDenyButton: true,
    confirmButtonText: "Historial de Pagos",
    denyButtonText: "Historial de Solicitud",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#2e7d32",
    denyButtonColor: "#18234f",
    cancelButtonColor: "#64748b",
  }).then((result) => {
    if (result.isConfirmed) {
      mostrarModalHistorialPagos(idSolicitud);
    } else if (result.isDenied) {
      mostrarModalHistorialSolicitud(idSolicitud);
    }
  });
};

